import i18next from "i18next";
import * as messages from "../../translations/messages.en.yml";
import * as fund from "../../translations/fund.en.yml";
import * as application from "../../translations/application.en.yml";
import $ from "jquery";

(function(lng, defaultNS, translations) {
    if ($.fn.select2) {
        $.fn.select2.defaults.set('language', lng);
    }
    i18next.init({lng, fallbackLng: ["en", "ru"], defaultNS});
    for (let ns in translations) {
        // @ts-ignore
        i18next.addResourceBundle(lng, ns, translations[ns], true, true)
    }
})("en", "messages", {
    messages,
    fund,
    application,
    'account_tree_grid': {
        Columns: {
            Name: 'Name',
            InitialBalance: 'Initial Balance',
            Balance: 'Balance'
        },
        ContextMenu: {
            Create: 'Create',
            CreatePortfolio: 'Create portfolio',
            CreateAccount: 'Create account',
            CreateCurrencyAccount: 'Create %currency% account',
            CreateCustomAccount: 'Create custom account',
            CreateEntity: 'Create entity',
            CreateEntityType: 'New %entityType%',
            CreateEntityAlreadyExisted: 'Already existed entity',
            CreateClient: 'Create client',
            CreateProject: 'Create project',
            Show: 'Show',
            Statement: 'Statement',
            PaymentDistributions: 'Payment distributions',
            Overview: 'Overview',
            Delete: 'Delete',
            Edit: 'Edit',
            Rename: 'Rename',
            Permission: 'Permissions',
            CreateFolder: 'Create folder',
            CreateFolderCommon: 'Create folder',
            CreateFolderUndefined: 'Create undefined folder',
            ExpandAll: 'Expand all',
            CollapseAll: 'Collapse all',
            ExpandOnly: 'Focus',
            Archive: 'Archive',
            UnArchive: 'UnArchive',
            Display: 'Display',
            Snapshot: 'Snapshot',
            Info: 'Info',
            InfoEdit: 'Edit info',
            InfoNotDefined: 'Info not defined',
            Resort: 'Resort A-Z'
        },
        Notify: {
            CreatePortfolioSuccess: 'Portfolio created successfully.',
            CreateCompanySuccess: 'Company created successfully.',
            CreateClientSuccess: 'Client created successfully.',
            CreateGroupSuccess: 'Group created successfully.',
            CreateProjectSuccess: 'Project created successfully.',
            CreatePhysicalSuccess: 'Child account created!',
            CreatePhysicalError: 'Can not create child physical account!',
            CreateInstituteSuccess: 'Institute added successfully.',
            RenameVirtualWarning: "Attention! If renamed - it will be also<br/>renamed owner object and sender, receiver in payments to it's sub accounts.<br/><br/>Press '<u>Esc</u>' to cancel this operation"
        },
        EntityType: {
            'company_native': 'Russian company',
            'company_foreign': 'Foreign company',
            'individual': 'Individual',
            'physical': 'Physical',
            'external': 'External'
        },
        AddPayment: {
            incoming: 'Add incoming payment',
            outgoing: 'Add outgoing payment',
            cashlessFromExternal: 'External',
            cashlessToExternal: 'External',
            cashlessInternal: 'Internal',
            cashlessInternalExchange: 'Exchange',
            cashInternalExchange: 'Exchange',
            cashInternal: 'Internal',
            cashlessToCashInternal: 'Cashless to Cash',
            cashToCashlessInternal: 'Cash to Cashless',
            cashFromExternal: 'From External',
            cashToExternal: 'To External',
            analytic: 'Analytic',
            analyticExchange: 'Analytic exchange'
        },
        SubClass: {
            fund: 'Fund',
            client: 'Client',
            project: 'Project',
            company: 'Company',
            institute: 'Institute',
            portfolio: 'Portfolio'
        },
        AvailableExternalUser: {
            HeaderTooltip: 'Available or not available account for external users',
            Available: 'Available for external users',
            NotAvailable: 'Not available for external users'
        },
        Loading: 'Loading...'
    },
    "payment_tree": {
        payment: "Payment details",
        amount: "Amount",
        payment_type: "Type",
        payment_state: "State",
        title: "Current payment %payment_id% tree"
    },
    "institute_type": {
        bank: "Bank",
        broker: "Broker"
    },
    "entity_permission_widget": {
        'header': {
            'account': 'Account',
            'permission': 'Permission'
        },
        'tooltip': {
            'permission_list':   'Display in the account tree',
            'permission_view':   'View payment of these accounts',
            'permission_edit':   'Change this account, create a child,\nedit and create related payments',
            'permission_delete': 'Delete account'
        }
    },
    "boolean_enum": {
        "true": "Yes",
        "false": "No"
    },
    "company_management_type_enum": {
        "own": "Own",
        "managed": "Managed"
    },
    "user_type_enum": {
        "internal": "Internal",
        "external": "External"
    },
    "locale_enum": {
        "ru": "Russian",
        "en": "English"
    },
    "company_type_enum": {
        "company_native": "Russian company",
        "company_foreign": "Foreign company",
        "individual": "Individual",
        "physical": "Physical",
        "external": "External"
    },
    "authorization_form": {
        "invalid_credentials": messages.home.invalid_credentials,
        "invalid_code": messages.home.invalid_code,
        "provide_username": messages.home.provide_username,
        "provide_password": messages.home.provide_password,
        "code_required": messages.home.code_required
    },
    "payment_request_priority": messages.payment_request_priority
});
